import React from 'react';

import { formatTierName } from '@/shared/lib/format';
import { Icon } from '@/shared/ui/Icon';

import styles from './TierDisplay.module.css';

type TierDisplayProps = {
  tierName: string;
  formatName?: boolean;
};

export const TierDisplay: React.FC<TierDisplayProps> = ({ tierName, formatName = true }) => {
  const displayName = formatName ? formatTierName(tierName) : tierName;

  return (
    <span className={styles.tierContainer}>
      <span className={styles.iconWrapper}>
        <Icon name="tier" size={14} />
      </span>
      <span className={styles.tierName}>{displayName}</span>
    </span>
  );
};
